// extracted by mini-css-extract-plugin
export default {"card":"P4-z","carouselContainer":"Q4-z","carouselContainerOverrides":"R4-z","carouselContent":"S4-z"};